export default __webpack_public_path__ + "static/media/tab_lecturer1.6d14bd30.png";